const Survey = {
    Questions: [],
    Answers: [],
    LoadingForm :false
}

const initialState = {
    Survey
}


export default initialState;


// WEBPACK FOOTER //
// ./src/Store.jsx